const themeContract = {
  argos: {
    pricing: {
      color: 'brand-2'
    },
    placeholder: {
      background: 'brand-3'
    }
  },
  habitat: {
    pricing: {
      color: 'brand-1'
    },
    placeholder: {
      background: 'brand-1'
    }
  },
  tu: {
    pricing: {
      color: 'brand-1'
    },
    placeholder: {
      background: 'brand-1'
    }
  }
}

export { themeContract }
